require("./bootstrap");

import Vue from "vue";
import VueRouter from "vue-router";

import router from "./Router/index";
import store from "./Store/index";
import App from "./App.vue";

// import VueAxios from "vue-axios";
// import axios from "axios";

// axios.defaults.withCredentials = true;

Vue.use(VueRouter);

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.state.auth.authenticated) {
            next({
                name: "login",
                // query: { redirect: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        if (to.name === "login" && store.state.auth.authenticated) {
            next({
                name: "adminHome",
            });
        } else {
            next();
        }
        // next(); // make sure to always call next()!
    }
});

import {
    LinkPlugin,
    ButtonPlugin,
    ModalPlugin,
    LayoutPlugin,
    TooltipPlugin,
    FormPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormSelectPlugin,
    FormTextareaPlugin,
    ListGroupPlugin,
    FormCheckboxPlugin,
    ImagePlugin,
    DropdownPlugin,
    BadgePlugin,
    NavbarPlugin,
    PaginationPlugin,
    CollapsePlugin,
    SpinnerPlugin,
    CardPlugin,
    TablePlugin,
    TabsPlugin,
    ToastPlugin,
    EmbedPlugin,
    FormTagsPlugin,
    FormFilePlugin,
    InputGroupPlugin,
    FormRadioPlugin,
    BIcon,
    BIconPencil,
    BIconXCircleFill,
    BIconXCircle,
    BIconQuestion,
    BIconArrowClockwise,
    BIconPlus,
    BIconPerson,
    BIconList,
    BIconCaretDown,
    BIconCaretUp,
    BIconTrash,
    BIconGeoAltFill,
    BIconExclamationCircle,
    BIconClockHistory,
    BIconCheckCircle,
    BIconMic,
    BIconStopFill,
    BIconFacebook,
    BIconTwitter,
    BIconChatLeftText,
    BIconVolumeUp,
    BIconChatLeft,
    BIconstack,
    BIconArrowLeftCircle,
    BIconEye,
    BIconFileEarmarkText,
    BAlert,
} from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(LinkPlugin);
Vue.use(ButtonPlugin);
Vue.use(ModalPlugin);
Vue.use(LayoutPlugin);
Vue.use(TooltipPlugin);
Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(ImagePlugin);
Vue.use(DropdownPlugin);
Vue.use(NavbarPlugin);
Vue.use(PaginationPlugin);
Vue.use(CollapsePlugin);
Vue.use(CardPlugin);
Vue.use(SpinnerPlugin);
Vue.use(TablePlugin);
Vue.use(ToastPlugin);
Vue.use(EmbedPlugin);
Vue.use(ListGroupPlugin);
Vue.use(BadgePlugin);
Vue.use(FormTagsPlugin);
Vue.use(FormFilePlugin);
Vue.use(InputGroupPlugin);
Vue.use(TabsPlugin);
Vue.use(FormRadioPlugin);

Vue.component("BIcon", BIcon);
Vue.component("BIconPencil", BIconPencil);
Vue.component("BIconXCircleFill", BIconXCircleFill);
Vue.component("BIconXCircle", BIconXCircle);
Vue.component("BIconQuestion", BIconQuestion);
Vue.component("BIconArrowClockwise", BIconArrowClockwise);
Vue.component("BIconPlus", BIconPlus);
Vue.component("BIconPlus", BIconPlus);
Vue.component("BIconPerson", BIconPerson);
Vue.component("BIconList", BIconList);
Vue.component("BIconCaretDown", BIconCaretDown);
Vue.component("BIconCaretUp", BIconCaretUp);
Vue.component("BIconTrash", BIconTrash);
Vue.component("BIconGeoAltFill", BIconGeoAltFill);
Vue.component("BIconExclamationCircle", BIconExclamationCircle);
Vue.component("BIconClockHistory", BIconClockHistory);
Vue.component("BIconCheckCircle", BIconCheckCircle);
Vue.component("BIconMic", BIconMic);
Vue.component("BIconStopFill", BIconStopFill);
Vue.component("BIconFacebook", BIconFacebook);
Vue.component("BIconTwitter", BIconTwitter);
Vue.component("BIconChatLeftText", BIconChatLeftText);
Vue.component("BIconVolumeUp", BIconVolumeUp);
Vue.component("BIconChatLeft", BIconChatLeft);
Vue.component("BIconstack", BIconstack);
Vue.component("BIconArrowLeftCircle", BIconArrowLeftCircle);
Vue.component("BIconEye", BIconEye);
Vue.component("BIconFileEarmarkText", BIconFileEarmarkText);
Vue.component("BAlert", BAlert);

import PortalVue from "portal-vue";
import VueLazyLoad from "vue-lazyload";

Vue.use(VueLazyLoad);

Vue.prototype.$eventBus = new Vue();

Vue.use(PortalVue);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

// const app = new Vue({
//     el: "#app",
//     router,
//     store,
//     components: { App },
// });

store.dispatch("auth/me").then(() => {
    const app = new Vue({
        el: "#app",
        router,
        store,
        components: { App },
    });
});
